import { AxiosResponse } from 'axios';

export interface PersonInfoToSendLetter {
  name: string;
  email: string;
}

export interface SentLetter {
  fileName: string;
  templateType: string;
  size: number;
  lastModified: string;
  documentTitle: string;
  recipientEmail: string;
  createdAt: string;
  key: string;
}

export interface SentLetters {
  sentLetters: SentLetter[];
}

export interface LetterTemplate {
  id: string;
  name: string;
  spanishName: string;
  description: string;
  canSend: boolean;
}

export interface LetterTemplateList {
  company: string;
  count: number;
  templates: LetterTemplate[];
}

export interface Recipient {
  id: string;
  name: string;
  email: string | null;
}

interface Recipients {
  insuredPerson: Recipient;
  driver: Recipient;
}

export interface LetterPrefill {
  templateId: string;
  pdfPreview: string;
  recipients: Recipients;
}

export interface EmailSendConfirmation {
  message: string;
}

export interface RequestErrorAlertProp {
  error: string;
}

export interface BadRequestMessage {
  message: string;
  error: string;
}

export const BadRequestMessageWarning =
  'Se ha producido un error al intentar cargar la página.\nEsto puede ser debido a un error en la conexión o a un error en el servidor.\n\nPor favor, inténtelo de nuevo más tarde.\nSi el problema persiste, póngase en contacto con el soporte técnico.';

export const getBadRequestMessage = (
  unsuccessfulRequest: string | null,
  requestResponse: AxiosResponse | undefined,
  error: unknown,
): BadRequestMessage => {
  if (!unsuccessfulRequest || !requestResponse) {
    return {
      message: BadRequestMessageWarning,
      error: '',
    };
  }

  const response = ((): string => {
    const parts = [
      `Method: (src/components/claims/sections/index.tsx) ${unsuccessfulRequest}`,
      `${error}`,
      `\tstatusCode: ${requestResponse.status}`,
      `\tcode: ${
        requestResponse.data?.code
          ? requestResponse.data.code
          : 'Error no proporcionó un código'
      }`,
      `\tmessage: ${
        requestResponse.data?.message
          ? requestResponse.data.message
          : 'Error no proporcionó un mensaje'
      }`,
    ];

    return parts.join('\n');
  })();

  let errorMessage = '';
  switch (unsuccessfulRequest) {
    case 'getLetterTemplatesList':
      errorMessage =
        'En este momento no se pueden ver las plantillas de cartas o documentos.';
      break;
    case 'getLetterPrefill':
      errorMessage =
        'En este momento no se puede generar una carta o documento.';
      break;
    case 'postDownloadSentLetter_Preview':
      errorMessage = 'En este momento no se puede ver la carta enviada.';
      break;
    case 'postDownloadSentLetter_Download':
      errorMessage = 'En este momento no se puede descargar la carta enviada.';
      break;
    case 'postDownloadModifiedLetterTemplate_Download':
      errorMessage =
        'En este momento no se puede descargar la carta modificada.';
      break;
    case 'postDownloadModifiedLetterTemplate_Send':
      errorMessage = 'En este momento no se puede enviar la carta modificada.';
      break;
  }

  return {
    message: [errorMessage, BadRequestMessageWarning].join('\n\n'),
    error: response,
  };
};
